import React, { useEffect, useState } from "react";
import { getUserData, loginUser } from "../redux/slices/userSlices";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ToastProvider from "../hooks/useToastProvider";
import CheckinStage, { DesignButton, u } from "../components/CheckinStage";

// Đăng nhập PG (T-FQJZ = A): POST /api/login → token Sanctum lưu trong redux-persist
function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const dataUser = useSelector(getUserData);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  useEffect(() => {
    if (dataUser) {
      navigate("/");
    }
  }, [dataUser]);

  const handleLogin = async () => {
    if (isLoading) return;
    if (formData.username === "" || formData.password === "") {
      ToastProvider({
        type: "error",
        content: "Vui lòng nhập đầy đủ thông tin",
      });
      return;
    }
    setIsLoading(true);
    try {
      await (dispatch(loginUser(formData) as any) as any).unwrap();
      ToastProvider({ type: "success", content: "Đăng nhập thành công" });
      navigate("/");
    } catch (err: any) {
      ToastProvider({
        type: "error",
        content: typeof err === "string" ? err : "Đăng nhập không thành công",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    fontSize: u(28),
    padding: `${u(18)} ${u(24)}`,
    borderRadius: u(14),
    marginTop: u(8),
  };

  return (
    <CheckinStage>
      <form
        className="absolute flex flex-col"
        style={{
          left: u(110),
          right: u(110),
          top: u(420),
          padding: u(36),
          borderRadius: u(24),
          background: "rgba(10, 24, 110, 0.55)",
          border: "1px solid rgba(140, 200, 255, 0.45)",
          boxShadow: "0 0 18px rgba(60, 130, 255, 0.45)",
        }}
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <label className="font-medium" style={{ fontSize: u(26) }}>
          Tên tài khoản
        </label>
        <input
          type="text"
          autoCapitalize="none"
          autoComplete="username"
          className="w-full bg-white text-[#0b1446] font-medium outline-none"
          style={inputStyle}
          placeholder="ID Đăng nhập"
          value={formData.username}
          onChange={(e) => setFormData({ ...formData, username: e.target.value })}
        />
        <label className="font-medium" style={{ fontSize: u(26), marginTop: u(24) }}>
          Mật khẩu
        </label>
        <input
          type="password"
          autoComplete="current-password"
          className="w-full bg-white text-[#0b1446] font-medium outline-none"
          style={inputStyle}
          placeholder="Mật khẩu"
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
        />
        <button type="submit" className="hidden" />
      </form>
      <DesignButton
        label={isLoading ? "Đang đăng nhập..." : "Đăng nhập"}
        y={832}
        onClick={handleLogin}
        disabled={isLoading}
      />
    </CheckinStage>
  );
}

export default Login;
